import { $carte_layout, $side_panel, map } from './_context.js';

export const MAP_PADDING_DEFAULT = 30;

/** True when the venue data panel is visible (not `carte-layout__data-panel--hidden`). */
export function isDataPanelOpen() {
    const $data_panel = document.querySelector('.carte-layout__data-panel');
    return !!($data_panel && !$data_panel.classList.contains('carte-layout__data-panel--hidden'));
}

export function syncFullscreenToggleButtons() {
    const layout = document.querySelector('.carte-layout');
    if (!layout) {
        return;
    }
    const active = layout.classList.contains('carte-layout--fullscreen');
    document.querySelectorAll('.js-toggle-fullscreen').forEach(function (btn) {
        btn.classList.toggle('js-toggle-fullscreen--active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
}

/**
 * Compute padding (px) so the "visible" map area excludes side panel and data panel.
 */
export function getMapPadding() {
    const defaultPadding = {
        top: MAP_PADDING_DEFAULT,
        right: MAP_PADDING_DEFAULT,
        bottom: MAP_PADDING_DEFAULT,
        left: MAP_PADDING_DEFAULT,
    };
    if (!$carte_layout) return defaultPadding;
    if (typeof window !== 'undefined' && window.innerWidth < 1080) {
        return defaultPadding;
    }
    if (!$carte_layout.classList.contains('carte-layout--floating-panels')) {
        return defaultPadding;
    }
    const dataPanelVisible = isDataPanelOpen();
    const $data_panel = document.querySelector('.carte-layout__data-panel');
    const dataPanelWidth = dataPanelVisible && $data_panel ? $data_panel.offsetWidth : 0;
    const panelOnLeft = $carte_layout.classList.contains('carte-layout__sidepanel-side-left');
    const panelOnRight = $carte_layout.classList.contains('carte-layout__sidepanel-side-right');
    const hasPanel = $side_panel && (panelOnLeft || panelOnRight);
    const sidePanelWidth = hasPanel ? $side_panel.offsetWidth : MAP_PADDING_DEFAULT;

    const left = panelOnLeft
        ? sidePanelWidth + (dataPanelVisible ? dataPanelWidth : MAP_PADDING_DEFAULT)
        : MAP_PADDING_DEFAULT;
    const right = panelOnRight
        ? sidePanelWidth + (dataPanelVisible ? dataPanelWidth : MAP_PADDING_DEFAULT)
        : MAP_PADDING_DEFAULT;
    return { top: MAP_PADDING_DEFAULT, right, bottom: MAP_PADDING_DEFAULT, left };
}

export function applyMapPadding() {
    if (!map || !$carte_layout) return;
    const padding = getMapPadding();
    map.setOptions({ padding });
}

export function fitBoundsOrCenterSingle(mapInstance, boundsInstance, padding, maxZoom) {
    if (!mapInstance || !boundsInstance) return;
    const ne = boundsInstance.getNorthEast();
    const sw = boundsInstance.getSouthWest();
    const spanLat = Math.abs(ne.lat() - sw.lat());
    const spanLng = Math.abs(ne.lng() - sw.lng());
    const isSinglePoint = spanLat < 1e-10 && spanLng < 1e-10;
    if (isSinglePoint) {
        mapInstance.setCenter(boundsInstance.getCenter());
        if (maxZoom != null) {
            mapInstance.setZoom(maxZoom);
        }
    } else {
        if (maxZoom != null) {
            google.maps.event.addListenerOnce(mapInstance, 'bounds_changed', function () {
                this.setZoom(Math.min(this.getZoom(), maxZoom));
            });
        }
        mapInstance.fitBounds(boundsInstance, padding);
    }
}
